import apiCall from "../axios/apiCall";

const controller = "sistema";

export default {
    getSystems: async () => {
        let response = { success: true };
        const method = ``;
        try {
            const apiResponse = await apiCall.get(controller, method);
            response.data = apiResponse?.data;
        } catch (error) {
            response = apiCall.handleCatch(error);
        }
        return response;
    },
    getMySystems: async () => {
        let response = { success: true };
        const method = `me`;
        try {
            const apiResponse = await apiCall.get(controller, method);
            response.data = apiResponse?.data;
        } catch (error) {
            response = apiCall.handleCatch(error);
        }
        return response;
    }
}